import { isValidElement } from 'react';
import { isArray, isNull, isString } from '@builder/utils';
export const isValidReactElement = (reactElement) => {
    if (isArray(reactElement)) {
        return reactElement.every(isValidReactElement);
    }
    return isValidElement(reactElement) || isString(reactElement) || isNull(reactElement);
};
